import styled from '@emotion/styled';

export const ControlButton = styled.button<{ selected: boolean }>`
    color: ${({ theme, selected }) => (selected ? theme.colors.secondary[900] : theme.colors.black[500])};
    border: 1px solid ${({ theme }) => theme.colors.black[200]};
    background-color: ${({ theme, selected }) => (selected ? theme.colors.black[100] : 'white')};
    outline: none;
    cursor: pointer;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    border-radius: 8px;
    padding: 6px;

    :hover {
        background-color: ${({ theme, selected }) => (selected ? theme.colors.black[100] : theme.colors.black[50])};
    }

    :active,
    :focus {
        outline: none;
    }
`;
